import { render, staticRenderFns } from "./ParallelRelayModule.vue?vue&type=template&id=6d00c31f&scoped=true&"
import script from "./ParallelRelayModule.vue?vue&type=script&lang=js&"
export * from "./ParallelRelayModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00c31f",
  null
  
)

export default component.exports